export const SUMMON_HOTKEY_SLUG = '__commandbar_summon_hotkey';
